import { useValidate } from "formvalidation/hooks";
import React, { useEffect } from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  focusOnMount?: boolean
  value: string
  onChanged: (newInstitutionNumber: string) => void
  onEnter?: () => void
  onEsc?: () => void

  validatorKey: string
}

const InstitutionNumberInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  const isValidInput = (input: string) => {
    if (input.trim().length === 0) return true;

    return /^\d+$/.test(input) &&
      input.length === serverReference.constants.bankAccount.exactInstitutionNumberLength;
  };
  const validate = async (input: string) => {
    const isValid = isValidInput(input);
    return isValid;
  };

  const formatInput = (input: string, e?) => {
    const sanitizedInput = input
      .trim()
      .replace(/\D/g, "")
      .substring(0, serverReference.constants.bankAccount.exactInstitutionNumberLength);

    if (isValidInput(sanitizedInput)) {
      e?.preventDefault();
      props.onChanged(sanitizedInput);
      return sanitizedInput;
    }

    return false;
  };

  const onPaste = (e) => {
    const text: string = e.clipboardData.getData("text").trim();
    formatInput(text, e);
  };

  const onBlur = () => {
    const formatted = formatInput(props.value);
    validate(formatted || props.value);
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: props.validatorKey,
    value: props.value,
    validate: validate,
    ref: semanticRef.ref
  });

  const onChange = (_, { value }) => {
    props.onChanged(value);
  };

  return <Input
    ref={semanticRef.refSetter}
    value={props.value}
    maxLength={serverReference.constants.bankAccount.exactInstitutionNumberLength}
    error={validation.error.hasError}
    onBlur={onBlur}
    onPaste={onPaste}
    onChange={onChange}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    fluid
    placeholder="000"
  />;
};

export default InstitutionNumberInput;